<template>
  <div style="margin-bottom:30px;">
      <el-form-item :prop="elementDefinition.key" :label="elementDefinition.label">
        <el-popover
                  v-if="elementDefinition.instructions"
                  placement="top-start"
                  :title="elementDefinition.key"
                  width="500"
                  trigger="hover"
                  :content="elementDefinition.instructions"
          >
              <i class="el-icon-info" slot="reference"></i>
          </el-popover>
          <el-input v-if="edit_mode !== false" @change="handleChange" v-model="selectedValue"></el-input>
          <div v-else :class="['form-readonly-value', !selectedValue || selectedValue === '' ? 'empty' : '']">{{ selectedValue || '(empty)' }}</div>
      </el-form-item>
    </div>
</template>

<script>
    export default {
        name: "FormElementShortText",
        props: [
            'elementDefinition',
            'initialValue',
            'handleFormElementValueChange',
            'edit_mode'
        ],
        data() {
            return {
                selectedValue: "",
            }
        },
        mounted() {
            this.selectedValue = this.initialValue
        },
        watch: {
            initialValue: function(val) {
                this.selectedValue = val
            }
        },
        methods: {
            handleChange(field_value) {
                let field_name = this.elementDefinition.key
                this.$emit('handleFormElementValueChange', {field_value, field_name})
            },
        }
    }
</script>

<style scoped>

</style>